import React, { useState } from "react";
import "./OurApproach.css";

const steps = [
  {
    id: 1,
    title: "Echange initial",
    duration: "30 min — gratuit",
    content: "On discute de votre projet par appel ou WhatsApp. On ecoute vos besoins, on vous explique ce qu'on peut faire, en combien de temps et pour quel budget. Pas de jargon, pas d'engagement. Juste une conversation pour voir si on est le bon partenaire pour vous.",
  },
  {
    id: 2,
    title: "Maquette et validation",
    duration: "2 a 5 jours",
    content: "Avant d'ecrire une seule ligne de code, on vous montre a quoi ressemblera votre projet : structure des pages, disposition des elements, couleurs. Vous validez, vous demandez des modifications, on ajuste. On ne commence le developpement que quand vous etes satisfait de la direction.",
  },
  {
    id: 3,
    title: "Developpement",
    duration: "Selon le projet",
    content: "On construit votre solution. Vous recevez des mises a jour regulieres et pouvez voir l'avancement en temps reel. Vous validez chaque etape importante avant qu'on passe a la suivante. Pas de surprise a la livraison.",
  },
  {
    id: 4,
    title: "Livraison et suivi",
    duration: "Apres la mise en ligne",
    content: "On met votre projet en ligne, on vous explique comment l'utiliser et on repond a vos questions. On reste disponibles apres la livraison pour les corrections, les mises a jour et les evolutions. Votre succes digital ne s'arrete pas le jour du lancement.",
  },
];

export default function OurApproach() {
  const [active, setActive] = useState(1);
  const current = steps.find(s => s.id === active);

  return (
    <section className="our-approach">
      <h2>Comment on travaille</h2>
      <div className="approach-container">
        <div className="approach-steps">
          {steps.map(step => (
            <button
              key={step.id}
              className={"approach-step" + (active === step.id ? " active" : "")}
              onClick={() => setActive(step.id)}
              type="button"
            >
              <span className="approach-step-num">{step.id}</span>
              <span className="approach-step-title">{step.title}</span>
            </button>
          ))}
        </div>
        <div className="approach-content">
          <div className="approach-content-header">
            <h3>{current.title}</h3>
            <span className="approach-duration">{current.duration}</span>
          </div>
          <p>{current.content}</p>
        </div>
      </div>
    </section>
  );
}
